import React, { useEffect, useState, lazy, Suspense } from 'react';
import { Redirect, useHistory } from 'react-router-dom';
import { Button, Col, message, notification, Row, Spin, Typography } from 'antd';
import '../../utils/pdfWorker';
import { QuoteOneTrueForm } from '@partsbadger/one-true-form';
import UserStore from '../../stores/UserStore';
import * as api from '@partsbadger/utils';
import { GAEvent, PageView } from '../../utils/tracking';
import SalesOrderStore from '../../stores/SalesOrderStore';
import PortalLoading from 'components/PortalLoading';
import { PageHeader } from 'components/PageHeader';
import RedirectPreservingUTMQuery from '../../common/RedirectPreservingUTMQuery';

const Feedback = lazy(() => import('components/Feedback'));

const { Title } = Typography;

export const QuoteNew = (props: any) => {
    const [loading, setLoading] = useState(true);
    const [quote, setQuote] = useState<any>(null);
    const [quoteToken, setQuoteToken] = useState<any>(null);
    const [showFeedbackModal, setShowFeedbackModal] = useState<boolean>(false);
    const history = useHistory();
    const [quoteId, setQuoteId] = useState<number | null>(null);

    // This paramenter will be availaable if the users is accesing from<Route /my-account/quotes/:id/continue/
    const { id } = props.match.params;

    const loadLasQuoteByEmail = () => {
        setLoading(true);

        let email = UserStore.user?.email;

        // If the customer has a contact use the email contact, the customer can have multiple contacts
        if (UserStore.user?.default_contact?.email) {
            email = UserStore.user.default_contact.email;
        }

        if (!email) {
            setLoading(false);
            return;
        }

        api.get(`/customer/quote/last/?email=${encodeURIComponent(email)}`)
            .then(data => {
                setQuote(data);
                setQuoteToken(data.uid);
            })
            .catch(err => {
                message.error('Error, please try again');
            })
            .finally(() => setLoading(false));
    };
    const loadLasQuoteByDraftId = (id: string) => {
        setLoading(true);

        let email = UserStore.user?.email;

        // If the customer has a contact use the email contact, the customer can have multiple contacts
        if (UserStore.user?.default_contact?.email) {
            email = UserStore.user.default_contact.email;
        }

        api.get(`/customer/quote/last?draft_id=${id}`)
            .then(data => {
                setQuote(data);
                setQuoteToken(data.uid);
            })
            .catch(err => {
                message.error('Error, please try again');
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        if (id) {
            loadLasQuoteByDraftId(id);
        } else {
            loadLasQuoteByEmail();
        }
    }, [id]);

    const goCheckoutPage = async (quote_uid: string, contact_id: number) => {
        await SalesOrderStore.createOrderDraft({ contact: contact_id, quotes: [quote_uid] }).then(order => {
            history.replace(`/my-account/orders/checkout/${order.id}/`);
        });
    };

    const redirectToQuotes = () => {
        if (quoteId) {
            return history.push(`/my-account/quotes/${quoteId}`);
        }
        history.push('/my-account/quotes');
    };

    if (!UserStore.isAuthenticated) {
        <RedirectPreservingUTMQuery to="/rapid-quote/start" />;
    }

    return (
        <>
            {loading ? (
                <PortalLoading />
            ) : (
                <>
                    <PageHeader>
                        <div className="d-flex justify-content-between align-items-baseline">
                            <Title level={1} className="mb-0">
                                New Quote
                            </Title>
                        </div>
                    </PageHeader>
                    <div className="container">
                        <div className={'quote-form'}>
                            {quote && quoteToken ? (
                                <>
                                    <QuoteOneTrueForm
                                        acquisition_source={'Portal'}
                                        quote={quote}
                                        token={UserStore.token ? UserStore.token : ''}
                                        onRequestOrder={goCheckoutPage}
                                        for_staff={false}
                                        current_user={UserStore?.user ? UserStore.user : undefined}
                                        onQuoteSubmitted={data => {
                                            GAEvent('Form', 'RFQ Submitted');

                                            PageView('/rapid-quote/success/');
                                            setShowFeedbackModal(true);

                                            if (data.quote_id) {
                                                setQuoteId(data.quote_id);
                                            }

                                            const args = {
                                                message: 'Your Quote was sent!',
                                                description:
                                                    "Thank you for using PartsBadger's Quote submission form. Your quote will be updated shortly!",
                                                duration: 20,
                                            };
                                            notification.success(args);
                                        }}
                                    />
                                </>
                            ) : null}

                            <Suspense fallback={<Spin />}>
                                <Feedback
                                    isQuotes={true}
                                    visible={showFeedbackModal}
                                    setVisible={setShowFeedbackModal}
                                    redirectToThisPage={() => redirectToQuotes()}
                                />
                            </Suspense>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};
